import React from 'react'

import dotDotDotImage from '../../../public/static/images/svg/dotDotDot.svg'

const DotDotDotLogo = (props) => {
  return (
      <img src={dotDotDotImage} />
  )
}

export default DotDotDotLogo